import { render, staticRenderFns } from "./glTable.vue?vue&type=template&id=753372e2"
import script from "./glTable.vue?vue&type=script&lang=js"
export * from "./glTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports